<div class="route_data">

    <a class="btn btn-dark" data-toggle="collapse" href="#optionCollapse" role="button" aria-expanded="false" aria-controls="optionCollapse">
		<p>點選收合</p>
    </a>

    <form [formGroup]="optionForm">
		<div class="collapse show" id="optionCollapse">
			<div class="card card-body">
				<div class="listbox">

					<!-- 時間判斷 -->
					<div class="box">
						<p class="tt">出發抵達</p>

						<div class="radiobox">
							<ul>
								<li>
									<input type="radio" formControlName="timeWay" value="now">
									<label>立即出發</label>
								</li>
								<li>
									<input type="radio" formControlName="timeWay" value="departure">
									<label>出發時間</label>
								</li>
								<li>
									<input type="radio" formControlName="timeWay" value="arrival">
									<label>抵達時間</label>
								</li>
							</ul>
						</div>

						<div class="date">
							<input class="form-control" type="datetime-local" placeholder="" formControlName="goTime"  [readonly]="optionForm.value.timeWay === 'now'">
						</div>
					</div>

					<!-- 運具選擇 -->
					<div class="box">
						<p class="tt">偏好運具</p>
						<div class="checkbox" formGroupName="trafficWay">
						<ul>
							<li><input type="checkbox" formControlName="3"><label>高鐵</label></li>
							<li><input type="checkbox" formControlName="4"><label>台鐵</label></li>
							<li><input type="checkbox" formControlName="5"><label>公車</label></li>
							<li><input type="checkbox" formControlName="6"><label>捷運</label></li>
							<li><input type="checkbox" formControlName="8"><label>渡輪</label></li>
						</ul>
						</div>
					</div>

					<div class="box">
						<p class="tt">轉乘時間段</p>
						<p>請設定您偏好的交通運具轉乘時段</p>
						<input type="range" class="form-range linebar" formControlName="transferTime" min="0" max="60"  step="5">
						<div class="rangetxt01">
							<p>0分鐘</p>
							<p>60分鐘</p>
						</div>
					</div>

					<div class="box">
						<p class="tt">時間/價格偏好</p>
						<p>旅運時間愈短，價格可能愈高</p>
						<input type="range" class="form-range linebar" formControlName="gc" min="0" max="1"  step="0.1">
						<div class="rangetxt01">
							<p>價格較便宜</p>
							<p>時間較短</p>
						</div>
					</div>

					<div class="box" formGroupName="firstMode">
						<p class="tt">第一哩路轉乘偏好</p>

						<div class="d-flex align-items-center">
							<input type="checkbox" formControlName="0"><label>步行</label>
						</div>
						<input type="range" class="form-range linebar" formControlName="time0" min="0" max="60"  step="5">
						<div class="rangetxt02">
							<p>{{optionForm.value.firstMode.time0}}分鐘</p>
						</div>

						<div class="d-flex align-items-center">
							<input type="checkbox" formControlName="3"><label>自行車</label>
						</div>
						<input type="range" class="form-range linebar" formControlName="time3" min="0" max="60"  step="5">
						<div class="rangetxt02">
							<p>{{optionForm.value.firstMode.time3}}分鐘</p>
						</div>


						<div class="d-flex align-items-center">
							<input type="checkbox" formControlName="2"><label>搭車</label>
						</div>
						<input type="range" class="form-range linebar" formControlName="time2" min="0" max="60"  step="5">
						<div class="rangetxt02">
							<p>{{optionForm.value.firstMode.time2}}分鐘</p>
						</div>
					</div>

					<div class="box" formGroupName="lastMode">
						<p class="tt">最後一哩路轉乘偏好</p>
						<div class="d-flex align-items-center">
							<input type="checkbox" formControlName="0"><label>步行</label>
						</div>
						<input type="range" class="form-range linebar" formControlName="time0" min="0" max="60"  step="5">
						<div class="rangetxt02">
							<p>{{optionForm.value.lastMode.time0}}分鐘</p>
						</div>

						<div class="d-flex align-items-center">
							<input type="checkbox" formControlName="3"><label>自行車</label>
						</div>
						<input type="range" class="form-range linebar" formControlName="time3" min="0" max="60"  step="5">
						<div class="rangetxt02">
							<p>{{optionForm.value.lastMode.time3}}分鐘</p>
						</div>


						<div class="d-flex align-items-center">
							<input type="checkbox" formControlName="2"><label>搭車</label>
						</div>
						<input type="range" class="form-range linebar" formControlName="time2" min="0" max="60"  step="5">
						<div class="rangetxt02">
							<p>{{optionForm.value.lastMode.time2}}分鐘</p>
						</div>
					</div>

		</div>

		<div class="btn01"><a role="button" (click)="showDetail()">開始搜尋</a></div>
		</div>
	</div>
  </form>
</div>
